import React, { FC, ReactElement } from 'react';
import Main from './components/mainPage/MainPage';
import { LiveMatchProvider } from './context';

const App: FC = (): ReactElement => {
  return (
    <LiveMatchProvider>
      <Main />
    </LiveMatchProvider>
  );
};

export default App;
